// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class DocumentHistoryRequests {
    /**
     * @returns {Promise<DocumentHistoryInitDataResponse>}
     */
    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'DocumentHistory/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {DocumentDownloadFilterSet} filters 
     * @returns {Promise<WebRecords<WebDocumentReloadData>>}
     */
    async GetData(filters) {
        return await SmrClient.FetchJson({
            url: 'DocumentHistory/GetData',
            method: "POST",
            body: filters
        });
    }

    /**
     * @param {number} id
     * @param {boolean} exportFiles
     * @returns {Promise<ValueResponse<ExportDocumentPrepareDownloadFileTask>>}
     */
    async ExportTaskRun(id, exportFiles) {
        return await SmrClient.FetchJson({
            url: 'DocumentHistory/ExportTaskRun',
            method: "POST",
            body: { id: id, exportFiles: exportFiles },
            bodyIsUrlParams: true
        });
    }
}

export default new DocumentHistoryRequests;